export const   fetching= 'FETCHING_INSTANT_RENTING_REQUESTS'
export const   fetched= 'FETCHED_INSTANT_RENTING_REQUESTS'
export const   update= 'UPDATE_INSTANT_RENTING_REQUESTS'
export const   sent= 'SENT_INSTANT_RENTING_REQUESTS'
export const   errored= 'ERROR_INSTANT_RENTING_REQUESTS'
export const   reset= 'RESET_INSTANT_RENTING_REQUESTS'
